import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@noom/wax-component-library';
import useCategories from '../../../social/hooks/useCategories';
import RecommendedList, { RecommendedListSkeleton, } from '../../../social/components/community/RecommendedList';
import { PageContainer } from './styles';
import withSDK from '../../../core/hocs/withSDK';
import useUserFilters from '../../../core/hooks/useUserFilters';
import userMatchesCommunityCategorySegment from '../../../helpers/userMatchesCommunityCategorySegment';
const NUMBER_OF_COMMUNITIES_PER_CATEGORY = 5;
const List = ({ categories = [], isLoading = false, }) => {
    if (isLoading) {
        return (React.createElement(React.Fragment, null, new Array(3).fill(1).map((_v, index) => (React.createElement(RecommendedListSkeleton, { key: index })))));
    }
    return (React.createElement(React.Fragment, null, categories === null || categories === void 0 ? void 0 : categories.map((category) => (React.createElement(RecommendedList, { category: category, key: category.categoryId, communityLimit: NUMBER_OF_COMMUNITIES_PER_CATEGORY })))));
};
const ExplorePage = ({ currentUserId }) => {
    const userFilters = useUserFilters(currentUserId);
    const [categories = [], , , loading] = useCategories({
        isDeleted: false,
    });
    const filteredCategories = categories.filter((cat) => userMatchesCommunityCategorySegment(userFilters, cat));
    return (React.createElement(PageContainer, null,
        React.createElement(Box, { mb: 2 },
            React.createElement(List, { categories: filteredCategories, isLoading: loading }))));
};
ExplorePage.propTypes = {
    currentUserId: PropTypes.string.isRequired,
};
export default withSDK(ExplorePage);
//# sourceMappingURL=index.js.map